import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FamilyHeaderComponent } from './family-header.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [FamilyHeaderComponent],
  imports: [CommonModule],
  exports: [FamilyHeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FamilyHeaderModule {};
